import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { Account } from "@/commons/services/Authorization";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ユーザーアカウント API 操作クラス
 */
export default class Accounts {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * POST Accounts
   *
   * - 実際には取得処理だが、ユーザーIDをクエリパラメータで渡したくない
   * - そのため、POSTにしてリクエストボディでユーザーIDを渡す
   */
  public async post(userStore: LoginUser, userId?: string): Promise<Account> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    // 引数のuserIdが無ければstoreから取得したものを使用する
    const requestBody: { userId: string } = { userId: userId ? userId : userStore.loginUser.userId };
    const requestUrl: string = UrlFormatter.format(RestUrl.Accounts, formatParams);
    const response = await this.commonService.executePost<Account>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * PATCH Accounts
   */
  public async patch(userStore: LoginUser, user: UpdateAccountsPatchModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.Accounts, formatParams);

    // APIのモデルに合わせてここで送信内容を調整
    const requestBody: UpdateAccountsPatchModel = {
      userId: user.userId,
      updateType: user.updateType,
      password: user.password,
      oldPassword: user.oldPassword,
      name: user.name,
      kana: user.kana,
      tel: user.tel,
      mail: user.mail,
      permissions: user.permissions,
      updated: user.updated
    };

    const response = await this.commonService.executePatch<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface UpdateAccountsPatchModel {
  /** ユーザーID */
  userId: string;
  /** 更新種別 */
  updateType: UpdateType;
  /** パスワード */
  password?: string;
  /** 旧パスワード */
  oldPassword?: string;
  /** 氏名 */
  name?: string;
  /** 氏名(カナ) */
  kana?: string;
  /** 電話番号 */
  tel?: string;
  /** メールアドレス */
  mail?: string;
  /** 権限 */
  permissions?: number[];
  /** 更新日時 */
  updated: number;
}

export enum UpdateType {
  MINE = 0,
  OTHER = 1
}
